import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { Label, Input, Column, Field, Control, Help } from "rbx";

import moment from "moment";
import Loading from "../../../components/Loading";
import {
  DriverSelect,
  OrderStatusSelect,
  LocationSelect
} from "../../../components/inputs";

import FilterButtons from "../../../components/FilterButtons";
import { useSystemCodes } from "../../../utils/hooks";
import { getFilterState } from "../../../utils";

function OrderFilters({ filters, onFilter, resetFilters, onClose }) {
  const INITIAL_FILTER_STATE = getFilterState("DEFAULT_ORDER_FILTERS");
  const SystemCodes = useSystemCodes({
    Category: "Order",
    CodeName: "OrderStatus"
  });
  const [inputs, setInputs] = useState({ ...filters });
  const [errors, setErrors] = useState([]);

  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    const updates = {};
    if (e.target.name === "StatusRecIdRef_in") {
      // const { options } = e.target;
      // const result = [];
      // for (let i = 0, l = options.length; i < l; i += 1) {
      //   if (options[i].selected) {
      //     result.push(parseInt(options[i].value));
      //   }
      // }
      // updates.StatusRecIdRef_in = result.length ? result : null;
      updates[e.target.name] = value;
    } else if (/RecIdRef/.test(e.target.name)) {
      updates[e.target.name] = parseInt(value);
    } else if (/OrderNumber/.test(e.target.name)) {
      updates[e.target.name] = !Number.isNaN(parseInt(value))
        ? parseInt(value)
        : undefined;
    } else if (/date/gi.test(e.target.name)) {
      if (
        e.target.name === "PickupDate_gt" ||
        e.target.name === "OrderDate_gt"
      ) {
        const [str] = e.target.name.split("_");
        updates[`${str}_gt`] = value;
        updates[`${str}_lt`] = moment(value).format("YYYY-MM-DD");

        console.log(updates);
      } else {
        updates[e.target.name] = value;
      }
    } else {
      updates[e.target.name] = value;
    }
    setInputs(prev => ({
      ...prev,
      ...updates
    }));
  };

  const handleClose = () => onClose(onFilter(inputs));
  const handleCancel = () => onClose(onFilter(filters));
  const handleReset = () => onClose(resetFilters());

  useEffect(() => {
    if (SystemCodes?.data?.length > 0 && !filters.StatusRecIdRef_in) {
      const newFilters = SystemCodes.data.filter(
        s =>
          s.CodeId === "U" ||
          s.CodeId === "DA" ||
          s.CodeId === "SCH" ||
          s.CodeId === "VEH" ||
          s.CodeId === "BK-E" ||
          s.CodeId === "EXP" ||
          s.CodeId === "IMP" ||
          s.CodeId === "RV"
      );
      INITIAL_FILTER_STATE.StatusRecIdRef_in = newFilters.map(f => f.RecId);
      setInputs({
        ...filters,
        StatusRecIdRef_in: newFilters.map(f => f.RecId)
      });
    }
  }, [INITIAL_FILTER_STATE.StatusRecIdRef_in, SystemCodes.data, filters]);

  useEffect(() => {
    if (inputs?.PickupDate_gt && inputs?.PickupDate_lt) {
      const start = moment(inputs.PickupDate_gt);
      const end = moment(inputs.PickupDate_lt);
      if (end.isBefore(start)) {
        setErrors(["PickupDate"]);
      } else {
        setErrors([]);
      }
    }
  }, [inputs.PickupDate_gt, inputs.PickupDate_lt]);

  if (!filters.StatusRecIdRef_in) {
    return <Loading />;
  }

  return (
    <div style={{ width: "100%", maxWidth: 1100 }}>
      <Column.Group>
        <Column>
          <Field>
            <Control>
              <Label>Order #</Label>
              <Input
                name="OrderNumber"
                type="text"
                value={inputs.OrderNumber}
                onChange={handleChange}
              />
            </Control>
          </Field>
          <Field>
            <Control>
              <Label>Order # From</Label>
              <Input
                name="OrderNumber_gt"
                type="text"
                value={inputs.OrderNumber_gt}
                onChange={handleChange}
              />
            </Control>
          </Field>
          <Field>
            <Control>
              <Label>Order # To</Label>
              <Input
                name="OrderNumber_lt"
                type="text"
                value={inputs.OrderNumber_lt}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control>
              <Label>Order Date From</Label>
              <Input
                color={
                  errors.some(item => /OrderDate/gi.test(item)) ? "danger" : ""
                }
                name="OrderDate_gt"
                type="date"
                value={inputs.OrderDate_gt}
                onChange={handleChange}
              />
            </Control>
          </Field>
          <Field>
            <Control>
              <Label>Order Date To</Label>
              <Input
                color={
                  errors.some(item => /OrderDate/gi.test(item)) ? "danger" : ""
                }
                name="OrderDate_lt"
                type="date"
                value={inputs.OrderDate_lt}
                onChange={handleChange}
              />
              <Help>
                {errors.some(item => /OrderDate/gi.test(item)) &&
                  "Must be after Order Date From"}
              </Help>
            </Control>
          </Field>
          <Field>
            <Control>
              <Label>Delivery Location ID</Label>
              <Input
                name="Del_LocationId_contains"
                type="text"
                value={inputs.Del_LocationId_contains}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control>
              <Label>Driver #</Label>
              <Input
                name="PickupDriver_contains"
                type="text"
                value={inputs.PickupDriver_contains}
                onChange={handleChange}
              />
            </Control>
          </Field>
          <Field>
            <Control>
              <DriverSelect
                icon="user"
                label="Driver"
                name="PickupDriverRecIdRef"
                value={inputs.PickupDriverRecIdRef}
                onChange={handleChange}
              />
            </Control>
          </Field>
          <Field>
            <Control>
              <Label>Delivery Location City</Label>
              <Input
                name="Del_City_contains"
                type="text"
                value={inputs.Del_City_contains}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control>
              <Label>Pickup Date From</Label>
              <Input
                color={
                  errors.some(item => /PickupDate/gi.test(item)) ? "danger" : ""
                }
                name="PickupDate_gt"
                type="date"
                value={inputs.PickupDate_gt}
                onChange={handleChange}
              />
            </Control>
          </Field>
          <Field>
            <Control>
              <Label>Pickup Date To</Label>
              <Input
                color={
                  errors.some(item => /PickupDate/gi.test(item)) ? "danger" : ""
                }
                name="PickupDate_lt"
                type="date"
                value={inputs.PickupDate_lt}
                onChange={handleChange}
              />
              <Help>
                {errors.some(item => /PickupDate/gi.test(item)) &&
                  "Must be after Pickup Date From"}
              </Help>
            </Control>
          </Field>
          <Field>
            <Control>
              <LocationSelect
                label="Pickup Location"
                name="PickupLocationRecIdRef"
                showHelp={false}
                value={inputs.PickupLocationRecIdRef}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control expanded>
              <Label>Customer Name</Label>
              <Input
                name="CustomerName_contains"
                type="text"
                value={inputs.CustomerName_contains}
                onChange={handleChange}
              />
            </Control>
          </Field>
          <Field>
            <Control expanded>
              <Label>Customer No</Label>
              <Input
                name="CustomerNo_contains"
                type="text"
                value={inputs.CustomerNo_contains}
                onChange={handleChange}
              />
            </Control>
          </Field>
          <Field>
            <Control expanded>
              <Label>Bill To Name</Label>
              <Input
                name="BillToName_contains"
                type="text"
                value={inputs.BillToName_contains}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
      </Column.Group>
      <Field>
        <Control>
          <OrderStatusSelect
            value={inputs.StatusRecIdRef_in}
            onChange={handleChange}
          />
        </Control>
      </Field>

      <hr />
      <FilterButtons
        errors={errors}
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </div>
  );
}
OrderFilters.propTypes = {
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func,
  resetFilters: PropTypes.func
};
export default OrderFilters;
